// extracted by mini-css-extract-plugin
export default {"countryContainer":"Country_countryContainer__nuVVg","img":"Country_img__-3HIJ","cases":"Country_cases__gfrCr","icon":"Country_icon__up9Uu"};